module.exports = {
  COVIDVAX: [
    'Нам подойдет любой из трех документов:',
    'Их можно скачать на портале госуслуг или сфотографировать бумажный вариант.',
    'Где взять эти документы',
    'https://mygig.zendesk.com/hc/ru/articles/4403014224145',
    'Сертификат о вакцинации',
    'Сертификат переболевшего',
    'Справка о медотводе',
  ],
};
